import { styled } from '@mui/material/styles';
import { Div } from '../../Atoms/Div';
import { Scheme } from '.';

export const Container = styled(Div)<{ scheme: Scheme }>`
  display: flex;
  height: 100%;
  transition: all 0.5s;
  background: ${(props) => props.scheme?.background};
`;
